import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { MultiTraitQueryService } from '../multi-trait-query.service';
import { TraitReference } from '../trait.reference.model';
import { TranslateService } from '@ngx-translate/core';
import { MultiTraitQueryContext } from '../multi-trait-query-context';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-step-select-traits',
    styleUrls: ['./step-select-traits.component.css'],
    templateUrl: './step-select-traits.component.html'
})
export class StepSelectTraitsComponent implements OnInit {

    subscriptionManager = new SubscriptionsManager();

    @Output() next = new EventEmitter<void>();
    @Input() active = false;

    traitReferences: TraitReference [];
    selectedTraits: TraitReference [] = [];
    textFilter = '';
    traitFilterPlaceHolder = 'multi-trait-query.panel.select.traits.filter.place.holder';

    constructor(private jhiLanguageService: JhiLanguageService,
                private queryContext: MultiTraitQueryContext,
                private multiTraitQueryService: MultiTraitQueryService,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.drawTree();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['active'] && this.active) {
            this.textFilter = '';
            if (!this.queryContext.hasSelectTraits()) {
                this.selectedTraits = [];
                this.queryContext.cleanSelectedTraits();
            }
        }
    }

    visitTraitReferences(traitReferences: TraitReference[], visit: (traitReference: TraitReference) => any) {
        for (const traitReference of traitReferences) {
            visit(traitReference);
            if (traitReference.children && traitReference.children.length) {
                this.visitTraitReferences(traitReference.children, visit);
            }
        }
        return traitReferences;
    }

    setParent(traitReferences: TraitReference[], parent: TraitReference) {
        for (const traitReference of traitReferences) {
            traitReference.parent = parent;
            if (traitReference.children && traitReference.children.length) {
                this.setParent(traitReference.children, traitReference);
            }
        }
        return traitReferences;
    }

    drawTree() {
        this.subscriptionManager.add = this.multiTraitQueryService.getTraitClassTree().subscribe((root: TraitReference) => {
            root.collapsed = false;
            this.traitReferences = this.setParent([root], null);
            this.visitTraitReferences(this.traitReferences, (traitReference: TraitReference) => {
                if (traitReference.parent) {
                    traitReference.collapsed = !traitReference.selectable;
                }
            });
        });
    }

    isNextEnabled(): boolean {
        return this.selectedTraits.length > 0;
    }

    onNext(): void {
        if (this.isNextEnabled()) {
            this.queryContext.cleanSelectedTraits();
            this.queryContext.setSelectedTraits(this.selectedTraits.map(value => Number(value.id)));
            this.next.emit();
        }
    }

    addSelectedTrait(traitReference: TraitReference) {
        if (!this.selectedTraits.includes(traitReference)) {
            this.selectedTraits.push(traitReference);
        }
    }

    deleteTrait(trait: TraitReference) {
        const idx = this.selectedTraits.findIndex(traitReference => traitReference.id === trait.id);
        if (idx >= 0) {
            this.selectedTraits.splice(idx, 1);
            this.queryContext.setSelectedTraits(this.selectedTraits.map(value => Number(value.id)));
        }
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }
}

@Component({
    selector: 'jhi-trait-tree',
    template: `
		<ul class="ul-tree" [class.ul-tree-level-zero]="isLevelZero">
			<li *ngFor="let traitReference of traitReferences">
				<ng-container>
					<div (click)="traitReference.children?.length ? collapse(traitReference) : selected(traitReference)"
						 style="cursor: pointer;" [hidden]="!matchesTextFilter(traitReference)">
						<span *ngIf="traitReference.children?.length > 0"
							  [ngClass]="isCollapsed(traitReference) ? 'fa fa-caret-up fa-rotate-90' : 'fa fa-caret-up fa-rotate-180'"
							  style="margin-right: 5px; color: rgb(51, 122, 183);"></span>
						<span *ngIf="!traitReference.children?.length"
							  style="display: inline-block;"></span>
						<span> {{ traitReference.name }} </span>
					</div>
				</ng-container>
				<jhi-trait-tree *ngIf="traitReference.children && !isCollapsed(traitReference)" [textFilter]="textFilter" [traitReferences]="traitReference.children" (onAddSelectedTrait)="addSelectedTrait($event)"></jhi-trait-tree>
			</li>
		</ul>
    `,
    styleUrls: ['./step-select-traits.component.css']
})
export class TraitTreeComponent {
    @Input() traitReferences: TraitReference [];
    @Input() isLevelZero: boolean;
    @Output() onAddSelectedTrait = new EventEmitter<TraitReference>();
    @Input() textFilter: string;


    isCollapsed(reference: TraitReference) {
        return reference.collapsed && this.textFilter === '';
    }

    matchesTextFilter(reference: TraitReference) {
        if (this.textFilter === '') {
            return true;
        }

        let result = reference.description.toLocaleLowerCase().indexOf(this.textFilter.toLocaleLowerCase()) > -1 || reference.name.toLocaleLowerCase().indexOf(this.textFilter.toLocaleLowerCase()) > -1;
        if (!result && reference.children.length > 0) {
            result = reference.children.some((p) => {
                return this.matchesTextFilter(p);
            });
        }

        if (result) {
            reference.collapsed = false;

        }
        return result;
    }

    collapse(reference: TraitReference) {
        return reference.collapsed = !reference.collapsed;
    }

    isSelectable(reference: TraitReference) {
        return reference.selectable;
    }

    selected(reference: TraitReference) {
        if (reference.selectable) {
            this.onAddSelectedTrait.emit(reference);
        }
    }

    addSelectedTrait(reference: TraitReference) {
        this.onAddSelectedTrait.emit(reference);
    }
}
